import React from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from './parts/theme-context.js';

var ThemeProvider = function ThemeProvider(_ref) {
  var theme = _ref.theme,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: theme
  }, children);
};

ThemeProvider.propTypes = {
  theme: PropTypes.oneOf(['light', 'dark']).isRequired
};
export { ThemeProvider as default };
